import React from 'react';
import {observer} from 'mobx-react';
import './inner-content.scss';
import {DisplayTypeEnum, Inches, RenderV2_DisplayItem, RenderV2Object} from '../render-v2-d';
import {MatSecondary} from '../mat-secondary/mat-secondary';
import {inchToPx} from '../frame-builder';
import {Spirit} from '../spirit/spirit';

type Props = {
    maxCols: number;
    width: number;
    height: number;
    columnGap: Inches;
    frame: RenderV2Object;
};

export const InnerContent = observer(({frame, maxCols, width, height, columnGap}: Props) => {
    const {displayMatrix, moulding} = frame;
    const itemsCount = (type: DisplayTypeEnum) => displayMatrix.flatMap(row => row).filter(i => i.displayType === type).length;
    const isDocument = (item: RenderV2_DisplayItem) => item.displayType === DisplayTypeEnum.Doc;
    const docRows = displayMatrix.map(row => row.filter(item => item.displayType === DisplayTypeEnum.Doc)).filter(row => row.length > 0);
    const isVertical = !docRows.some(row => row.length > 1);

    return (
        <div
            id="inner-content"
            style={{
                gridTemplateColumns: `repeat(${maxCols}, auto)`,
                gridTemplateRows: `${itemsCount(DisplayTypeEnum.Insignia) > 0 ? inchToPx(frame.railTop) : ''} ${isVertical ? `repeat(${itemsCount(DisplayTypeEnum.Doc)}, 1fr)` : '1fr'} ${itemsCount(DisplayTypeEnum.Lino) > 0 ? inchToPx(frame.railBottom) : ''}`,
                justifyContent: 'center',
                inset: `${inchToPx(moulding.mouldingThickness)}`,
                width: inchToPx(width),
                height: inchToPx(height),
                columnGap: inchToPx(columnGap),
                paddingTop: !itemsCount(DisplayTypeEnum.Insignia) ? inchToPx(frame.railTop) : '',
                paddingBottom: !itemsCount(DisplayTypeEnum.Lino) ? inchToPx(frame.railBottom) : '',
            }}
        >
            {displayMatrix.map((row, rIdx) =>
                row.map((item, cIdx) => {
                    if (!item) return null;

                    return (
                        <div
                            key={`${rIdx}-${cIdx}`}
                            style={{
                                gridRow: `${item.rowSpan || 1}`,
                                gridColumn: `${item.colSpan || 1}`,
                                marginBottom: isDocument(item) ? inchToPx(item.gapBelow) : 0,
                            }}
                            className="inner-container"
                        >
                            {isDocument(item) && (item.mat2Color || item.mat2ImageURL) ? (
                                <MatSecondary item={item} />
                            ) : (
                                <img
                                    src={item.url}
                                    alt={item.displayType}
                                    style={{
                                        width: item.width === -1 ? 'auto' : inchToPx(item.width),
                                        height: item.height === -1 ? 'auto' : inchToPx(item.height),
                                    }}
                                />
                            )}
                        </div>
                    );
                }),
            )}

            {frame.spiritMode && <Spirit frame={frame} />}
        </div>
    );
});
